'use client';
import { generateMd5HashWithRandomBytes } from '@bgzt/log';
import { apiFetcher } from '~/apis/api-fetcher';
import { LogParams } from './type';

/** @see https://quicket.atlassian.net/wiki/spaces/BUN/pages/833290328/App */
export const postLog = (params: LogParams) => {
  const md5Hash = generateMd5HashWithRandomBytes(params);
  return apiFetcher.post<{ message: string }>(`/api/log/v2/events`, params, {
    headers: {
      'Content-Type': 'application/json',
      'X-BUN-LOG-HASH': md5Hash,
    },
  });
};
